import React, { createContext, useContext, useEffect, useCallback, useState } from 'react';
import config from '../config';

const CssContext = createContext();

export const useCss = () => useContext(CssContext);

export const CssProvider = ({ children }) => {
  const [customBgImage, setCustomBgImage] = useState(null);
  const [customBgEnabled, setCustomBgEnabled] = useState(false);

  // CSS verilerini API'den al ve uygula
  const fetchAndApplyCss = useCallback(async () => {
    try {
      if (!window.rh || !window.rh.cr) {
        console.warn('Güvenlik sistemi yüklenmemiş, default CSS kullanılıyor');
        return;
      }

      const payload = JSON.stringify({
        process_id: "get-css",
        user_id: "",
      });

      const keys = await window.rh.cr(payload);

      const response = await fetch(
        `${config.apiBaseUrl}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "hk": keys[0],
            "hh": keys[1]
          },
          body: payload,
        }
      );

      if (!response.ok) {
        console.warn('CSS API isteği başarısız, default CSS kullanılıyor');
        return;
      }

      const result = await response.json();

      let cssData = result;

      if (result.status && result.data) {
        cssData = result.data;
      } else if (result.status === false) {
        console.warn('CSS API hatası:', result.message || 'Bilinmeyen hata');
        return;
      }

      if (cssData && typeof cssData === 'object') {
        console.log('✅ CSS verileri API\'den alındı:', Object.keys(cssData).length, 'özellik');

        // CSS custom properties olarak uygula
        Object.entries(cssData).forEach(([cssVar, value]) => {
          if (cssVar.startsWith('--') && value) {
            document.documentElement.style.setProperty(cssVar, value);
          }
        });

        // Arkaplan görseli özel alanları
        if (cssData.customBgImage) setCustomBgImage(cssData.customBgImage);
        if (cssData.customBgEnabled !== undefined) setCustomBgEnabled(!!cssData.customBgEnabled);
      } else {
        console.warn('Geçersiz CSS verisi, default CSS kullanılıyor');
      }

    } catch (error) {
      console.error('CSS yükleme hatası:', error);
      console.warn('Default CSS kullanılıyor');
    }
  }, []);

  const updateCustomBg = useCallback((base64) => {
    setCustomBgImage(base64);
    setCustomBgEnabled(true);
  }, []);

  const removeCustomBg = useCallback(() => {
    setCustomBgImage(null);
    setCustomBgEnabled(false);
  }, []);

  // Uygulama açılırken CSS'i yükle
  useEffect(() => {
    fetchAndApplyCss();
  }, [fetchAndApplyCss]);

  return (
    <CssContext.Provider value={{
      fetchAndApplyCss,
      customBgImage,
      customBgEnabled,
      setCustomBgEnabled,
      updateCustomBg,
      removeCustomBg,
    }}>
      {children}
    </CssContext.Provider>
  );
};
